
import React, { useState } from 'react';
import { apiClient } from '../apiClient';

const EmailChangeModal = ({ isOpen, onClose, currentEmail, onEmailChangeRequested }) => {
    const [newEmail, setNewEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!newEmail) {
            setError('新しいメールアドレスを入力してください。');
            return;
        }
        if (newEmail !== confirmEmail) {
            setError('メールアドレスが一致しません。');
            return;
        }
        if (newEmail === currentEmail) {
            setError('現在のメールアドレスと同じアドレスは設定できません。');
            return;
        }

        setLoading(true);
        try {
            const response = await apiClient.post('/v1/email-change-request', { newEmail });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'リクエストに失敗しました。');
            }
            onEmailChangeRequested();
            onClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
                <h2 className="text-xl font-bold mb-4">請求先メールアドレス変更</h2>
                {error && <p className="text-red-500 mb-4 bg-red-100 p-3 rounded-md text-sm">{error}</p>}
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">現在のメールアドレス</label>
                        <p className="mt-1 text-gray-900">{currentEmail}</p>
                    </div>
                    
                    <div>
                        <label htmlFor="newEmail" className="block text-sm font-medium text-gray-700">新しいメールアドレス</label>
                        <input
                            id="newEmail"
                            type="email"
                            required
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>

                    <div>
                        <label htmlFor="confirmEmail" className="block text-sm font-medium text-gray-700">確認用メールアドレス</label>
                        <input
                            id="confirmEmail"
                            type="email"
                            required
                            value={confirmEmail}
                            onChange={(e) => setConfirmEmail(e.target.value)}
                            className="mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                    </div>

                    <div className="flex justify-end gap-2 pt-4">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 font-medium rounded-md text-sm"
                            disabled={loading}
                        >
                            キャンセル
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-indigo-600 text-white hover:bg-indigo-700 font-medium rounded-md text-sm flex items-center"
                            disabled={loading}
                        >
                            {loading ? '送信中...' : '確認メールを送信'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EmailChangeModal;
